import React, { useEffect, useState } from "react";
import Slide from "./Slide";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import leftArrow from "../icons/caret-left-solid.svg";
import rightArrow from "../icons/caret-right-solid.svg";
import { scroller } from "react-scroll";
import { nanoid } from "nanoid";
// import Arrows from "./Arrows";

// import NavSpacer from "./NavSpacer";

function SlideShow({
  slides,
  slideShowName,
  slideHeight,
  scrollOffset,
  shopSlideShow,
}) {
  // const [centreMode, setCentreMode] = useState(true);
  const [slideWidth, setSlideWidth] = useState(60);
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;

      if (width < 815) {
        setSlideWidth(100);
      } else if (width < 1045) {
        setSlideWidth(67);
      } else {
        setSlideWidth(60);
      }
    };

    handleResize(); // set correct width on mount
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const isItAShopSlideShow = () => {
    if (shopSlideShow) {
      return "shopSlideShow";
    } else {
      return "";
    }
  };

  const executeScroll = () => {
    scroller.scrollTo(slideShowName, {
      duration: 100,
      delay: 0,
      smooth: "linear",
      offset: scrollOffset,
    });
  };

  const handleClick = slideShowName => {
    executeScroll(slideShowName);
  };

  return (
    <React.Fragment>
      <div
        className={`slideShowContainer ${slideShowName} `}
        id={`${isItAShopSlideShow()}`}
      >
        <div className='slideCounter'>
          {currentIndex + 1} / {slides.length}
        </div>
        <Carousel
          emulateTouch={true}
          showThumbs={false}
          // infiniteLoop={true}
          showStatus={false}
          showArrows={true}
          onChange={(index) => setCurrentIndex(index)}
          onSwipeStart={() => {
            handleClick(slideShowName);
          }}
          id='slideShow'
          className={`slideShow `}
          showIndicators={false}
          swipeScrollTolerance={30}
          centerSlidePercentage={slideWidth} //was 60
          selectedItem={0}
          preventMovementUntilSwipeScrollTolerance={true}
          renderArrowPrev={(onClickHandler, hasPrev, label) =>
            hasPrev ? (
              <div
                className='arrowCursor arrow arrowLeft'
                onClick={() => {
                  onClickHandler();
                  handleClick();
                }}
              >
                <img className='arrowPic' src={leftArrow} alt={label} />
              </div>
            ) : null
          }
          renderArrowNext={(onClickHandler, hasNext, label) =>
            hasNext ? (
              <div
                className='arrowCursor arrow arrowRight'
                onClick={() => {
                  onClickHandler();
                  handleClick();
                }}
              >
                <img src={rightArrow} className='arrowPic' alt={label} />
              </div>
            ) : null
          }
        >
          {slides.map((theSlide, index) => (
            <Slide
              image={theSlide.image}
              imageSm={theSlide.imageSm}
              title={theSlide.title}
              description={theSlide.description}
              alt={theSlide.alt}
              key={nanoid()}
              sold={theSlide.sold}
              price={theSlide.price}
              slideHeight={slideHeight}
              shopSlide={shopSlideShow}
              isFirst={index === 0}
            />
          ))}
        </Carousel>
      </div>
      {/* <NavSpacer /> */}
    </React.Fragment>
  );
}

export default SlideShow;
